import React, { createContext, useContext } from 'react';

export type FdsPageKey = string;

type NavFn = (page: FdsPageKey) => void;

const FdsNavContext = createContext<NavFn>(() => {});

export function FdsNavProvider({ navigate, children }: { navigate: NavFn; children: React.ReactNode }) {
  return <FdsNavContext.Provider value={navigate}>{children}</FdsNavContext.Provider>;
}

export function useFdsNav() {
  return useContext(FdsNavContext);
}
